import React, { forwardRef } from 'react';

import { ColorlessIconProps as ColorlessIconPropsRaw, IconBaseProps, iconCls } from './types';
import './Icon.css';

type ColorlessIconProps = ColorlessIconPropsRaw & {
    colorless: true;
};

const isColorlessProps = (props: ColorlessIconProps | IconBaseProps): props is ColorlessIconProps => {
    return 'colorless' in props && props.colorless;
};

export const SVGContainer = forwardRef<SVGSVGElement, ColorlessIconProps | IconBaseProps>(
    function SVGContainer(props, ref) {
        const isColorless = isColorlessProps(props);
        // убираем библиотечные свойства из svg, чтобы не триггерить warning
        const { colorless, size, role, viewBox, color, title, ...restProps } = isColorlessProps(props)
            ? props
            : { ...props, colorless: false };

        return (
            <svg
                {...restProps}
                width={size}
                height={size}
                viewBox={viewBox}
                fill="none"
                ref={ref}
                className={iconCls(isColorless ? { role: props.role, color: props.color } : {}, [props.className])}
                focusable="false"
                aria-hidden="true"
            >
                {title && <title>{title}</title>}
                {props.children}
            </svg>
        );
    },
);
